import { Trash2, Users, CalendarDays } from "lucide-react";
import { useLang } from "@/context/LangContext";

const STATUS = {
  finished: "bg-emerald-100 text-emerald-900",
  in_progress: "bg-amber-100 text-amber-900",
  not_started: "bg-stone-100 text-stone-700",
};

export const AssignmentCard = ({ a, onDelete }) => {
  const { t } = useLang();
  const tt = t.teacher;
  const total = a.targets?.length ?? 0;
  return (
    <article className="bg-white border border-[#E5DCCB] p-5 flex flex-col gap-3" data-testid={`teacher-assignment-${a.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-display text-xl font-bold" dir="auto">{a.book?.title || tt.deletedBook}</p>
          <p className="text-xs text-stone-600 mt-1">{t.subjects[a.book?.subject]?.name} · {t.lib.level} {a.book?.level}</p>
        </div>
        <button onClick={() => onDelete(a)} className="p-2 rounded-full text-red-800 hover:bg-red-50 shrink-0" aria-label={tt.deleteTask} data-testid={`teacher-delete-assignment-${a.id}`}><Trash2 className="w-4 h-4" /></button>
      </div>
      <div className="flex flex-wrap gap-3 text-xs text-stone-700">
        <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {a.whole_class ? tt.wholeClass : tt.someN(total)}</span>
        {a.due_date && <span className="inline-flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5" /> {a.due_date}</span>}
      </div>
      {a.note && <p className="text-sm bg-[#FAF7F2] border-s-2 border-[#B45309] px-3 py-2" dir="auto">{a.note}</p>}
      <div>
        <div className="flex justify-between text-xs mb-1"><span>{tt.done}</span><span data-testid={`teacher-assignment-done-${a.id}`}>{a.done} / {total}</span></div>
        <div className="h-1.5 bg-[#E5DCCB] rounded-full overflow-hidden"><div className="h-full bg-[#047857]" style={{ width: `${total ? (a.done / total) * 100 : 0}%` }} /></div>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {(a.targets || []).map((x) => (
          <span key={x.student_id} className={`text-xs rounded-full px-2.5 py-1 ${STATUS[x.status]}`}>{x.name} · {tt.st[x.status]}{x.status === "in_progress" ? ` ${tt.pageShort(x.page + 1)}` : ""}</span>
        ))}
      </div>
    </article>
  );
};
